import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../core/authentication';

@Component({
  selector: 'app-product-select-list',
  templateUrl: './product-list.component.html'
})
export class ProductListComponent implements OnInit {
  productSelectForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit() {
  }

  // convenience getter for easy access to form fields
  get f() { return this.productSelectForm.controls; }


  productSelected() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.productSelectForm.invalid) {
      return;
    }
    this.loading = true;
  }

}
